/**
 * @copyright 2018 Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @author 2018 Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import Vue from 'vue'
import { loadState } from '@nextcloud/initial-state'
import Logger from './logger.js'
import store from './store.js'

import PersonalTotpSettings from './components/PersonalTotpSettings.vue'

Vue.mixin({
	methods: {
		t,
	},
})

store.replaceState({
	totpState: loadState('twofactor_totp', 'state'),
})

const View = Vue.extend(PersonalTotpSettings)
new View({
	store,
}).$mount('#twofactor-totp-settings')

Logger.debug('personal settings loaded and rendered')
